// extracted by mini-css-extract-plugin
export var dropdownContainer = "_m4-0";
export var leftAlign = "_m4-4";
export var listItem = "_m4-2";
export var listItemWrapper = "_m4-1";
export var operationText = "_m4-3";